import React, { useContext, useMemo } from "react";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import { AuthContext } from "../../context/Auth/AuthContext";
import useDashboardMetrics from "../../hooks/useDashboardMetrics";
import BackdropLoading from "../../components/BackdropLoading";

import DateRangeFilter from "./DateRangeFilter";
import MetricsCards from "./MetricsCards";
import AgentsRanking from "./AgentsRanking";
import QueuesChart from "./QueuesChart";
import DailyTrendChart from "./DailyTrendChart";
import PresenceList from "./PresenceList";

const useStyles = makeStyles(theme => ({
	container: {
		paddingTop: theme.spacing(3),
		paddingBottom: theme.spacing(4),
	},
	section: {
		marginTop: theme.spacing(3),
	},
}));

const Dashboard = () => {
	const classes = useStyles();
	const { user } = useContext(AuthContext);

	const userQueueIds = useMemo(() => {
		if (user?.queues?.length > 0) {
			return user.queues.map(q => q.id);
		}
		return [];
	}, [user?.queues]);

	const {
		loading,
		metrics,
		dateFrom,
		dateTo,
		agentId,
		activePreset,
		setDateFrom,
		setDateTo,
		setAgentId,
		applyPreset,
		refresh,
	} = useDashboardMetrics({ queueIds: userQueueIds });

	if (loading && !metrics) {
		return <BackdropLoading />;
	}

	return (
		<Container maxWidth="lg" className={classes.container}>
			<DateRangeFilter
				dateFrom={dateFrom}
				dateTo={dateTo}
				agentId={agentId}
				agents={metrics?.filterUsers}
				activePreset={activePreset}
				onDateFromChange={setDateFrom}
				onDateToChange={setDateTo}
				onAgentChange={setAgentId}
				onPreset={applyPreset}
				onRefresh={refresh}
			/>

			<MetricsCards summary={metrics?.summary} />

			<Grid container spacing={3} className={classes.section}>
				<Grid item xs={12} md={8}>
					<DailyTrendChart dailyTrend={metrics?.dailyTrend} />
				</Grid>
				<Grid item xs={12} md={4}>
					<PresenceList presence={metrics?.presence} />
				</Grid>
			</Grid>

			<Grid container spacing={3} className={classes.section}>
				<Grid item xs={12} md={5}>
					<AgentsRanking agents={metrics?.agents} />
				</Grid>
				<Grid item xs={12} md={7}>
					<QueuesChart queues={metrics?.queues} />
				</Grid>
			</Grid>
		</Container>
	);
};

export default Dashboard;
